import React from "react";

const Chapter9 = () => {
  return (
    <>
      <h2>
        How much information is there about E. <em>E. coli</em> in the South
        Platte River?
      </h2>
      <p>
        Data from over 5,000 samples collected from 166 sites between 2009 and
        2014 are used for this Water Quality Assessment Tool. Data were gathered
        from the Colorado Data Sharing Network and the Colorado Department of
        Public Health and Environment database. These two repositories maintain
        data that is collected using Quality Assurance Project Plans and
        maintain strict adherence to approved field collection and lab analysis
        procedures.
      </p>
    </>
  );
};

export default Chapter9;
